export enum iconEnum {
	tree = 'tree',
	logo = 'logo',
	logo_mini = 'logo_mini',
	checkmark = 'checkmark',
	exclamation_mark = 'exclamation_mark',
	burger = 'burger',
	building = 'building',
	bell = 'bell',
	user = 'user',
	user_fill = 'user-fill',
	users = 'users',
	users_group = 'users_group',
	sensor = 'sensor',
	pencil = 'pencil',
	delete = 'delete',
	eye = 'eye',
	eye_hide = 'eye_hide',
	gear = 'gear',
	sign_out = 'sign_out',
	energy = 'energy',
	comfort = 'comfort',
	tasks = 'tasks',
	technical_status = 'technical_status',
	filter = 'filter',
	map_pin = 'map_pin',
	dashboard = 'dashboard',
	help = 'help',
	bar_chart = 'bar_chart',
	home = 'home',
	add = 'add',
	sort = 'sort',
	sort_arrow_down = 'sort_arrow_down',
	sort_arrow_up = 'sort_arrow_up',
	sort_arrows = 'sort_arrows',
	arrow_backward = 'arrow_backward',
	arrow_down = 'arrow_down',
	arrow_forward = 'arrow_forward',
	clock = 'clock',
	animated_clock = 'animated_clock',
	panorama = 'panorama',
	system_state = 'system_state',
	floor = 'floor',
	room = 'room',
	search = 'search',
	camera = 'camera',
	overall_good = 'overall-good',
	overall_warning = 'overall-warning',
	overall = 'overall',
	lock = 'lock',
	unloc = 'unloc',
	add_user = 'add-user',
	add_organization = 'add-organization',
	warning_rate = 'warning-rate',
	rise_rate = 'rise-rate',
	super_admin_crown = 'super-admin-crown',
	organization = 'organization',
	digital_twin = 'digital-twin',
	refresh = 'refresh',
	calendar = 'calendar',
	cmms = 'cmms',
	incident = 'incident',
	request = 'request',
	asset = 'asset',
	extension = 'extension',
	info = 'info',
	attachment = 'attachment',
	files = 'files',
	file = 'file',
	other = 'other',
	checkList = 'checklist',
	attach_file = 'attach-file',
	kpi_timeseries = 'kpi-timeseries',
	grouping = 'grouping',
	filter_sort = 'filter-sort',
	table = 'table',
	table_active = 'table-active',
	timeline = 'timeline',
	timeline_active = 'timeline-active',
	count_range = 'count-range',
	multiselect = 'multiselect',
	speedometer = 'speedometer',
	text = 'text',
	multitext = 'multitext',
	priority = 'priority',
	hub = 'hub',
	category = 'category',
	routine = 'routine',
	tasks_completed = 'tasks_completed',
	flag = 'flag',
	cancel = 'cancel',
	edit = 'edit',
	tableView = 'table-view',
	calendar_v2 = 'calendar-v2',
	gavel = 'gavel',
	report = 'report',
	demography = 'demography',
	handshake = 'handshake',
	stylus_note = 'stylus_note',
	ifc = 'ifc',
	sidebar = 'sidebar',
	upload_violet = 'upload_violet',
	checklist_borderless = 'checklist-borderless',
	link_nomapped = 'link-nomapped',
	link_mapped = 'link-mapped',
	frame = 'frame',
	copy = 'copy',
	report_sign = 'report_sign',
	robot = 'robot',
	apps = 'apps',
	file_import = 'file_import',
	arrow_right = 'arrow_right',
	import_tool = 'import_tool',
	remove_attachment = 'remove-attachment',
	download = 'download',
	email = 'email',
	calendar_disabled = 'calendar-disabled',
	list_view = 'list-view',
	list_view_disabled = 'list-view-disabled',
	export_pdf = 'export-pdf',
}
